import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Injectable()
export class CCMCMatSidenavHelperService {
    sidenavInstances: MatSidenav[];

    constructor() {
        this.sidenavInstances = [];
    }

    setSidenav(id: any, instance: any) {
        this.sidenavInstances[id] = instance;
    }

    getSidenav(id: any) {
        return this.sidenavInstances[id];
    }
}
